import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const toISO = (d) => format(d, "yyyy-MM-dd");

/** Friendly date picker used everywhere instead of the native date input. */
export const DatePicker = ({
  value,
  onChange,
  placeholder = "Pilih tanggal",
  clearLabel = "Hapus tanggal",
  testid,
  className = "h-10 w-44",
  fromYear = 1930,
  toYear = new Date().getFullYear() + 3,
}) => {
  const [open, setOpen] = useState(false);
  let selected;
  try {
    selected = value ? parseISO(value) : undefined;
  } catch {
    selected = undefined;
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          data-testid={testid}
          className={`${className} justify-start font-normal ${
            value ? "" : "text-muted-foreground"
          }`}
        >
          <CalendarDays size={15} className="mr-2 shrink-0" />
          {value && selected ? format(selected, "dd MMM yyyy") : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          captionLayout="dropdown"
          showOutsideDays={false}
          fromYear={fromYear}
          toYear={toYear}
          classNames={{
            caption: "flex justify-center pt-1 relative items-center gap-2",
            caption_label: "hidden",
            caption_dropdowns: "flex gap-2 items-center [&_.rdp-vhidden]:hidden",
            dropdown:
              "h-8 rounded-lg border border-gray-200 bg-white px-2 text-sm font-medium",
            dropdown_month: "",
            dropdown_year: "",
          }}
          onSelect={(d) => {
            onChange(d ? toISO(d) : "");
            setOpen(false);
          }}
          initialFocus
        />
        {value && (
          <button
            data-testid={testid ? `${testid}-clear` : undefined}
            className="w-full border-t border-gray-100 py-2 text-sm text-muted-foreground hover:text-foreground"
            onClick={() => {
              onChange("");
              setOpen(false);
            }}
          >
            {clearLabel}
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
};
